import api from '@/services/Api';
import { Category } from '@/models/repairModule/referenciel/Category'

class RepairFileProspectService {
  async update(repairFileId, data) {
    if (data instanceof FormData) {
      const response = await api.put(
        '/distributor/repair-file/prospect/update/' + repairFileId,
        data,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      return response.data
    } else {
      const response = await api.put(
        '/distributor/repair-file/prospect/update/' + repairFileId,
        data)
      return response.data
    }
  }

  async getCategoryDetailByRepairFileId(repairFileId) {
    const response = await api.get(
      '/distributor/repair-file/prospect/get-category-detail-by-repair-id/' + repairFileId)

    return new Category(
      response.data.technicalId,
      response.data.boomerangId,
      response.data.name,
      response.data.manufacturerId,
      response.data.isProspectCategory,
      response.data.prospectFolderPictureMandatory,
      response.data.prospectCategoryPicture,
      response.data.prospectCategoryDescription
    )
  }

  async addNewDocumentToRepairFileProspect(formData) {
    const response = await api.put(
      '/distributor/repair-file/prospect/add-new-document',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })

    return response.data
  }

  async addNewPictureToRepairFileProspect(formData) {
    const response = await api.put(
      '/distributor/repair-file/prospect/add-new-picture',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })

    return response.data
  }

  async removePictureFromRepairFileProspect(data) {
    const response = await api.put(
      '/distributor/repair-file/prospect/remove-picture-from-repair-file-prospect',
      data)
    return response.data
  }

  async removeDocumentFromRepairFileProspect(data) {
    const response = await api.put(
      '/distributor/repair-file/prospect/remove-document-from-repair-file-prospect',
      data)
    return response.data
  }

  async getQRCodeToken(repairFileId, requestor_collaborator_id) {
    const response = await api.get(
      '/distributor/repair-file/prospect/qr-code/token/' + repairFileId
      + '?requestor_collaborator_id=' + requestor_collaborator_id)
    return response.data
  }

  async validateRepairFileQrCodeToken(token){
    const data = {
      qr_code_token: token
    }
    const response = await api.post(
      '/distributor/repair-file/prospect/qr-code/token/validation', data)

    return response.data
  }

  async sendPictureWithQrCodeToken(data) {
    const response = await api.put(
      '/distributor/repair-file/prospect/qr-code/send-picture',
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    return response.data
  }

  async confirmPictureAddedByQrCode(repairFileId, qrCodeToken, requestorCollaboratorId) {
    let data = {
      repair_file_id: repairFileId,
      qr_code_token: qrCodeToken,
      requestor_collaborator_id: requestorCollaboratorId
    }

    const response = await api.put(
      '/distributor/repair-file/prospect/qr-code/confirm-picture-added',
      data
    )
    return response.data
  }

  async saveManufacturerProspectOptionChoiceFromEmailSelection(data) {
    const response = await api.post(
      '/distributor/repair-file/prospect/email-manufacturer-selection-choice',
      data)
    return response.data
  }

  async sendProspectManufacturerResponseInformation(data) {
    if (data instanceof FormData) {
      const response = await api.post(
        '/distributor/repair-file/prospect/add-manufacturer-information',
        data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      return response.data
    } else {
      const response = await api.post(
        '/distributor/repair-file/prospect/add-manufacturer-information',
        data)
      return response.data
    }
  }
}

export default new RepairFileProspectService()
